<!--
스마트폰 업로더
-->
<template>
    <div class="">
        

        <!-- 세션 없음 -->
        <div v-show="! openedPhotoSession">
            <div class="uk-alert-primary" uk-alert>
                <a class="uk-alert-close" uk-close></a>
                <p>
                    Click [TAKE A PHOTO WITH PHONE] on PC
                </p>
            </div>

            <div class="uk-placeholder uk-text-center uk-text-muted uk-text-large">
                <i class="material-icons uk-text-middle" style="font-size: 2rem">
                    link_off
                </i>
                <span class="uk-text-middle">
                    unlinked with PC
                </span>
            </div>
        </div>

        

        <!-- 세션있음 -->
        <div v-show="openedPhotoSession" class="opened-session">

            <!-- S3 업로드영역 -->
            <div v-show="openS3Upload" class="">
                <input type="file" class="s3-file-input" ref="s3-file-input" @change="onS3FileInputChange" multiple />

                <!-- 업로드 안내 메세지 -->
                <div class="s3-upload-clickable" @dragenter="s3Uploading = true" @dragleave="s3Uploading = false" @dragover.prevent @drop.prevent="onS3DndDrop" @click="onS3DndClick">
                    <i class="material-icons uk-text-middle">
                        cloud_upload
                    </i><br />
                    Drop files here or<br/>
                    Click to upload <br />
                    (US SERVER)

                    <div class="s3-dnd-msg uk-flex uk-flex-column uk-flex-center uk-flex-wrap-middle" :class="s3Uploading ? 'dragged' : null">
                        <loading-icon
                            class="uk-text-middle uk-margin-top uk-margin-bottom"
                            bg-color="#fff"
                            fore-color="#333"
                        ></loading-icon>
                        <div class="uk-text-large">
                            uploading...
                        </div>

                    </div>

                </div>


            </div>
            

            <!-- 로컬 업로드 영역 -->
            <div v-show="openLocalUpload">
                <form action="/files" :id="formId">
                    <input type="hidden" name="_token" :value="csrfToken"/>
                    <input type="hidden" name="type" :value="type"/>
                    <input v-if="tempId" type="hidden" name="temp_id" :value="tempId"/>
                    <input v-if="cmId" type="hidden" name="cm_id" :value="cmId"/>
                    <input v-if="prodId" type="hidden" name="prod_id" :value="prodId"/>
                    <input v-if="userId" type="hidden" name="user_id" :value="userId"/>


                    <!-- javascript 미지원시 fallback 처리 -->
                    <div class="fallback">
                        <input name="file" type="file" multiple />
                    </div>

                    <!-- 업로드 안내 메세지 -->
                    <div class="dz-message needsclick">
                        <i class="material-icons uk-text-middle">
                            camera
                        </i>
                        Touch here
                    </div>
                </form>
            </div>

            

            <!-- 업로드된 파일 리스트 -->
            <div v-show="items.length > 0" class="uploaded-items">
                <div v-for="item in items" :key="item.id" class="uploaded-item">
                    
                    <!-- 삭제 버튼 -->
                    <a class="remove-btn" @click="removeUploadedFile(item)" title="click to remove">
                        <i class="material-icons">delete</i>
                    </a>

                    <!-- 썸네일 -->
                    <div class="thumb">
                        <!-- 이미지 -->
                        <img 
                            v-if="item.is_img === 1"
                            :src="item.url" 
                            class="img-file"
                        />

                        <!-- 기타파일 -->
                        <i v-if="item.is_img !== 1" class="material-icons etc-file">
                            attach_file
                        </i>
                    </div>

                    

                    <!-- 파일명 -->
                    <div class="file-name" :title="item.name">
                        {{ item.name }}
                    </div>

                    <!-- 파일정보 -->
                    <div class="file-info">
                        

                        <div class="size" :title="item.size">
                            {{ item.size }}
                        </div>
                        <div class="uploaded_by" :title="item.uploaded_by_nick">
                            by {{ item.uploaded_by_nick }}
                        </div>
                        <div class="created_at" :title="item.created_at">
                            at {{ item.created_at }}
                        </div>
                    </div>

                    
                    

                    

                </div>
            </div>

            <!-- 메세지 -->
            <div class="title-msg">
                LINKED WITH PC
            </div>
            <div class="sub-msg">
                Take a photo
            </div>
            <div class="session-code">
                {{ sessionCode }}
            </div>

            <!-- 스마트폰 촬영 종료 버튼 -->
            <button 
                type="button" 
                class="uk-button uk-button-danger uk-button-large uk-width-1-1"
                @click="endPhotoSession"
                title="촬영을 종료합니다"
            >                
                <span uk-icon="icon: close"></span>
                unlink with PC
            </button>

        </div>
        
        
        
        
    </div>

</template>

<script>
    import LoadingIcon from "../common/loading-icon";
    // dropzone
    import * as Dropzone from '../../../../dropzone/dist/dropzone-amd-module.js';
    Dropzone.autoDiscover = false;

    // 세션정보 갱신시간
    let session_refresh_timeout = 3000;
    
    // vue component
    export default {
        components: {LoadingIcon},
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null
            },
            
            /**
             * 촬영세션 용 현재 사용자 ID
             */
            sessionOwner: {
                type: Number,
                default: null
            },

            /**
             * 업로드서버 Code\System\UploadServer
             */
            uploadServer: {
                type: String,
                default: 's3-us',
            },
        },
        data: function () {
            return {
                
                /**
                 * 업로드가 완료된 파일 배열
                 * [
                 *      {}, 서버에서 받아온 업로드된 파일정보
                 *      .
                 *      .
                 *      .
                 *      {
                 *          App\Http\Controllers\Web\Files\Store 참고
                 *      }
                 * ]
                 */
                items: [],

                // 세션연결중 여부
                openedPhotoSession: false,

                // 세션객체
                session: null,

                // AWS 라이브러리 s3객체
                s3: null,
                s3Region: 'us-east-1',
                s3PoolId: 'us-east-1:4230e52f-a048-4d4d-80ea-c6dc31823eb9',
                s3Bucket: 'gonelo-img-us',

                // s3 업로드딩중
                s3Uploading: false,

                // s3 업로드 루트디렉토리 (ap, demo, local)
                s3Basedir: 'local',
            };
        },
        computed: {
            // S3업로드 영역 open 여부
            openS3Upload: function () {
                switch (this.uploadServer) {
                    case 's3-us':
                        return true;
                        break;
                }
                return false;
            },

            // 로컬(웹서버)업로드 영역 open 여부
            openLocalUpload: function () {
                return this.uploadServer === 'local';
            },

            formId: function () {
                return this.get_cmp_id();
            },

            type: function () {
                return this.session ? this.session.f_type : null;
            },

            tempId: function () {
                return this.session ? this.session.f_temp_id : null;
            },

            cmId: function () {
                return this.session ? this.session.f_cm_id : null;
            },

            prodId: function () {
                return this.session ? this.session.f_prod_id : null;
            },

            userId: function () {
                return this.session ? this.session.f_user_id : null;
            },

            sessionCode: function () {
                return this.session ? this.session.session_code : null;
            },
        },
        watch: {
        },
        mounted: function () {
            let cmp = this;

            // Dropzone 생성
            this.myDropzone = new Dropzone("#"+this.formId, {
                maxFilesize: 10, // MB
                timeout: 90000, // 1분 30초, 밀리세컨드기준
            });
            //console.log(myDropzone);
            document.querySelector("#"+this.formId).classList.add("dropzone");

            // dropzone 이벤트 리스닝
            let myDropzone = this.myDropzone;
            myDropzone.on("success", function(file, response) {
                // 배열에 추가
                cmp.items.push(response.uploaded);

                // dropzone 업로드 영역에서 제거
                myDropzone.removeFile(file);
            });
            myDropzone.on("sending", function(file, xhr, formData) {
                //Execute on case of timeout only
                xhr.ontimeout = function(e) {
                    let bg = document.createElement('div');
                    bg.style.cssText = 'position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 120px; padding: 1rem; color: #fff; background-color: #ff3300; z-index: 2000;';

                    let title = document.createElement('div');
                    title.style.cssText = 'font-size: 1.5rem; text-align: center;';
                    title.innerText = 'TIME OUT';

                    let desc = document.createElement('div');
                    desc.style.cssText = 'font-size: 1rem; text-align: center;';
                    desc.innerText = '일시적으로 네트워크가 불안정합니다. 새로고침 후 다시 시도하세요.';

                    file.previewTemplate.appendChild(bg);
                    bg.appendChild(title);
                    bg.appendChild(desc);

                };
            });

            // 초기화 작업
            this.init();

            // 최초에 세션 읽어옴
            this.loadSession();



            
        },
        methods: {
            /**
             * 초기화
             */
            init() {
                // AWS 세팅
                if (this.uploadServer !== 'local') {
                    AWS.config.update({
                        region: this.s3Region,
                        credentials: new AWS.CognitoIdentityCredentials({
                            IdentityPoolId: this.s3PoolId
                        })
                    });

                    this.s3 = new AWS.S3({
                        apiVersion: "2006-03-01",
                        params: { Bucket: this.s3Bucket }
                    });

                    // 루트디렉토리 결정
                    switch (window.location.hostname) {
                        case 'global.gonelo.com':
                        case 'gonelo.com':
                            this.s3Basedir = 'ap';
                            break;
                        case 'demo.global.gonelo.com':
                            this.s3Basedir = 'demo';
                            break;
                        default:
                            this.s3Basedir = 'local';
                            break;
                    }

                }

            },

            /**
             * S3 파일업로드 관련 이벤트들
             */
            onS3DndClick () {
                this.$refs['s3-file-input'].click();
            },
            onS3DndDrop (e) {
                const files = e.dataTransfer.files
                this.s3Upload(files);
            },
            onS3FileInputChange (e) {
                const files = e.target.files;
                this.s3Upload(files);
            },


            /**
             * S3로 업로드함.
             */
            s3Upload(files) {

                if (!files.length) {
                    return alert("Please choose a file to upload first.");
                }

                this.s3Uploading = true;

                for (let i = 0; i < files.length; i++) {
                    let file = files[i];

                    // 같은파일명인경우 덮어씀. 파일명에 시분초마이크로 붙여서 구분함
                    let fileName = moment().format('HHmmssSSS') + file.name;
                    let albumPhotosKey = encodeURIComponent(this.s3Basedir)
                        + '/' + moment().format('YYYY')
                        + '/' +  moment().format('MMDD')
                        + '/';

                    let photoKey = albumPhotosKey + fileName;

                    // Use S3 ManagedUpload class as it supports multipart uploads
                    let upload = new AWS.S3.ManagedUpload({
                        params: {
                            Bucket: this.s3Bucket,
                            Key: photoKey,
                            Body: file,
                            ContentType: file.type,
                        }
                    });
                    //console.log(file.type);

                    /**
                     * todo : 멀티파일업로드시, 1개씩 순차적으로 실행되도록 처리안함
                     * AWS에서 잘 처리하는 것 같아서 둠.
                     * 나중에 이슈있으면 순차처리되도록 프라미스처리부분 수정하면됨.
                     */
                    let promise = upload.promise();
                    const cmp = this;
                    promise.then(
                        function(data) {
                            console.log("Successfully uploaded photo.");
//                            console.log(data);

                            let uploaded = {
                                s3_region: cmp.s3Region,
                                s3_bucket: data.Bucket,
                                s3_key: data.Key,
                                url: data.Location,
                                mime: file.type,
                                bytes: file.size,
                                name: file.name,
                            };
                            cmp.insertS3(uploaded);

                        },
                        function(err) {
                            console.log(err);
                            return alert("There was an error uploading your photo: ", err.message);
                        }
                    ).finally(() => {
                        //console.log('finally!');
                        cmp.s3Uploading = false;
                    });

                    //console.log('end promise' + i);
                }



            },

            /**
             * 업로드된 파일을 삭제한다
             */
            removeUploadedFile: function (uploaded) {
                // 컨펌
                if (! confirm('Are you sure, remove the file?')) {
                    return;
                }

                // 프라미스처리로 한건씩 처리
                let promise = new Promise((resolve, reject) => resolve());

                // S3인경우 S3에서 먼저 삭제진행

                if (parseInt(uploaded.storage) === 2) {
                    promise = promise.then(() => {
                        return new Promise((resolve, reject) => {
                            this.s3.deleteObject({Key: uploaded.s3_key}, function (err, data) {
                                if (err) {
                                    reject(err.message);
                                    return;
                                }
                                console.log("Successfully deleted photo.");
                                resolve();
                            });
                        });
                    });

                }

                promise.then(() => {
                    // ajax로 업로드파일 삭제진행
                    let cmp = this;
                    let opts = {
                        type: 'delete',
                        url: '/files/'+uploaded.hashname,
                        data: {
                            '_token': this.csrfToken,
                        },

                        success: function (res) {

                            // 배열에서 제거
                            let index = _.findIndex(cmp.items, function (v) {
                                return v.id === uploaded.id;
                            });
                            cmp.items.splice(index, 1);

                        }
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                }).catch((msg) => {
                    if (msg) {
                        alert(msg);
                    }
                });


            },


            /**
             * S3업로드 결과처리
             * @param uploaded 업로드정보
             */
            insertS3: function (uploaded) {
                //console.log(uploaded);

                // ajax
                let cmp = this;
                let opts = {
                    type: 'post',
                    url: '/files',
                    data: {
                        _token: this.csrfToken,
                        type: this.type,
                        temp_id: this.tempId,
                        cm_id: this.cmId,
                        prod_id: this.prodId,
                        user_id: this.userId,
                        return_id: this.returnId,
                        storage: 2,

                        external_url: uploaded.url,
                        mime: uploaded.mime,
                        bytes: uploaded.bytes,
                        name: uploaded.name,

                        s3_region: uploaded.s3_region,
                        s3_bucket: uploaded.s3_bucket,
                        s3_key: uploaded.s3_key,
                    },

                    success: function (res) {
                        //console.log(res);

                        // 배열에 추가
                        cmp.items.push(res.uploaded);

                    }
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            },


            /**
             * 촬영을 종료한다.
             */
            endPhotoSession: function () {
                // ajax로 세션종료
                let cmp = this;
                let opts = {
                    type: 'delete',
                    url: '/photo-sessions',
                    data: {
                        '_token': this.csrfToken,
                    },

                    success: function (res) {
                        cmp.openedPhotoSession = false;
                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);  
            },

            /**
             * 세션정보를 얻어온다 (ajax 처리)
             * 
             * 주의 : uploader.vue, upload-on-phone.vue 동일하게 관리되는 메소드
             *       나중에 부모만들어서 상속처리해야함
             */
            loadSession: function () {
                let cmp = this;

                
                
                // ajax로 업로드파일 삭제진행
                let opts = {
                    type: 'get',
                    url: '/photo-sessions/my',

                    success: function (res) {
                        let response_session = res.session;
                        /**
                         * 응답온 세션이 현재 내 컴포넌트의 세션이 맞는지 검증
                         * - 검증하지 않으면, 동시에 두개 상품에서 컴포넌트 실행하면
                         *   같은 사용자의 세션이기때문에 두개 컴포넌트 모두 세션실행중으로 표시됨
                         */
                        if (response_session && cmp.validateSession(response_session) === false) {
                            response_session = null;
                        }
                        
                        // 세션정보 저장
                        cmp.session = response_session;
                        if (cmp.session) {
                            // 세션오픈으로 설정
                            cmp.openedPhotoSession = true;

                            // 최초 실행시, 변경버전 기록
                            if (! cmp.curr_changed) {
                                cmp.curr_changed = cmp.session.changed;
                            }
                        } else {
                            // 세션종료로 설정
                            cmp.openedPhotoSession = false;
                        }

                        // 세션이 살아있으면
                        if (cmp.openedPhotoSession) {
                            // 정보가 변경되었는지 비교
                            if (cmp.curr_changed !== cmp.session.changed) {
                                // 변경됨
                                // 변경작업 실행
                                cmp.changedJob(cmp.session.changed);
                                
                            } else {
                                // 변경안됨
                                //3초뒤 재호출처리
                                setTimeout(cmp.loadSession, session_refresh_timeout);
                            }

                        }

                    }
                };

                // ajax 실행
                $.app.ajax.module.background(opts);  
            },

            /**
             * 변경이 발생했을때, 처리해줘야할 작업을 기술
             * 
             */
            changedJob: function (changed) {
                //console.log('changed : ' + changed);

                // 변경버전 기록
                this.curr_changed = changed;
                if (this.openedPhotoSession) {
                    //3초뒤 재호출처리
                    setTimeout(this.loadSession, session_refresh_timeout);
                }
            },

            /**
             * 현재 이 컴포넌트의 세션정보가 맞는지 검증
             * @return bool
             */
            validateSession: function (response_session) {
                // 로그인 유저의 세션이기때문에 무조건 통과
                return true;
            },

        }
    }
</script>

<style lang="scss" scoped>
    // 리스트 영역
    .uploaded-items{
        background-color: #fff;
    }

    // 업로드 아이템
    .uploaded-item {
        position: relative;
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid #cfcfcf;

        // 파일 썸네일
        .thumb {
            // 이미지
            .img-file {
                object-fit: contain; 
                width: 120px; 
                height: 120px;
            }
            // 기타파일
            .etc-file {
                font-size: 120px;
            }
        }

        // 삭제
        .remove-btn i{
            position: absolute;
            top: 50px;
            right: 50px;
            font-size: 40px;
            color: #f0506e;

        }

        // 파일명
        .file-name {
            color: #000;
            font-weight: bold;
        }

        // 파일정보
        .file-info {

            .size, .uploaded_by, .created_at {
                padding: 3px;
                color: #999;
            }
        }

        


        

        
    }

    // 스마트폰 촬영중 안내영역
    .opened-session {
        text-align: center;
        .title-msg {
            color: #1e87f0;
            font-size: 2rem;
        }
        .sub-msg {
            color: #999;
            font-size: 1rem;
            margin-bottom: 10px;
        }
        .session-code {
            color: #000;
            font-size: 1.5rem;
            margin-bottom: 20px;
        }
    }

    // s3업로드 클릭영역
    .s3-upload-clickable {
        border: 2px dashed #0087F7;
        border-radius: 5px;
        background: white;
        margin-bottom: 5px;

        font-size: 1.5rem;
        color: #aaa;
        text-align: center;
        padding: 2em;

        cursor: pointer;
        position: relative;

        i.material-icons {
            font-size: 3rem;
        }

        .s3-dnd-msg {
            position: absolute;
            left: 0;
            top: 0;
            background-color: #0f7ae5;
            //opacity: 0.9;
            width: 100%;
            height: 100%;
            min-height: 200px;
            color: #fff;
            display: none;

            &.dragged {
                display: block;
            }
        }
    }

    .s3-file-input {
        display: none;
    }

</style>